module.exports = {
      id: "audio-replay-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#audio-replay",
      toString: function () {
        return this.url;
      }
    }